import { useState } from "react";
import { JellyfinAdapter, type JellyfinItem } from "../../adapters/static/jellyfin";

export interface JellyfinConnectStepProps {
  onConnected: (items: JellyfinItem[], baseUrl: string, apiKey: string, userId: string, serverName: string) => void;
}

export function JellyfinConnectStep({ onConnected }: JellyfinConnectStepProps) {
  const [baseUrl, setBaseUrl] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleConnect = async () => {
    setError(null);
    setLoading(true);
    try {
      const { userId, serverName } = await JellyfinAdapter.authenticate(baseUrl, apiKey);
      const lib = await JellyfinAdapter.getLibrary(baseUrl, apiKey, userId);
      onConnected(lib.items, baseUrl, apiKey, userId, serverName);
    } catch (e: unknown) {
      setError(e instanceof Error ? e.message : "Failed to connect");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <h3>Connect Jellyfin</h3>
      <p>Find your API key in Jellyfin Dashboard → Administration → API Keys.</p>
      <input value={baseUrl} onChange={(e) => setBaseUrl(e.target.value)} placeholder="http://jellyfin.local:8096" style={{ width: "100%", padding: 8, marginBottom: 8 }} />
      <input value={apiKey} onChange={(e) => setApiKey(e.target.value)} placeholder="API key" style={{ width: "100%", padding: 8, marginBottom: 8 }} />
      <button onClick={handleConnect} disabled={loading || !baseUrl || !apiKey}>
        {loading ? "Connecting..." : "Connect"}
      </button>
      {error && <div style={{ color: "#c00", marginTop: 12 }}>{error}</div>}
    </div>
  );
}
